function sogouSugg() {
  const suggTail = '';
  const info = {
    inputId: 'keyword',
    sugNum: 10,
    sugScriptId: 'sug',
    checkInterval: 500,
  };
  window.sug = {};
  const { sug } = window;
  const sugStatus = { focus: false, lastKw: '', cache: {}, isRequesting: false, currentSugKw: '', isClose: 0 };
  window.sogou = window.sogou || {};
  const { sogou } = window;
  sogou.sug = function (res) {
    if (!res) return false;
    const Q = [res.q, res.s.map(item => item.q)];
    if (Q[0] !== '') {
      sugStatus.cache[Q[0]] = Q;
    }
    sugStatus.isRequesting = false;
  };

  // 处理请求的数据
  function escapeForSpecialChars(input) {
    if (input !== null) return input.replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
    return '';
  }

  function unescapeForSpecialChars(input) {
    if (input !== null) return input.replace('&amp;', '&').replace('&lt;', '<')
      .replace('&gt;', '>')
      .replace('&quot;', '"');
    return '';
  }

  function getElementId(Q) {
    return document.getElementById(Q);
  }

  function strip(Q) {
    return Q.replace(/(^[\s\t\xa0\u3000]+)|([\u3000\xa0\s\t]+x24)/g, '');
  }

  function createWrapper() {
    sugStatus.lastKw = getElementId(info.inputId).value;
    sugStatus.focus = false;
    addListener();
  }

  function ajaj(S) {
    if (window.showSugg && window.showSugg === '0') {
      return;
    }
    const cache = sugCache(S);
    if (cache) {
      sogou.sug(cache);
      return;
    }
    const url = `https://sor.html5.qq.com/api/getsug?key=${S}&sugtime=${Date.now()}&s=1&pid=v.sogou.com&m=window.sogou.sug&cb=window.sogou.sug&source=wapsearch`;
    let sugdiv = getElementId(info.sugScriptId);
    if (sugdiv) {
      document.body.removeChild(sugdiv);
    }
    sugdiv = document.createElement('script');
    sugdiv.id = info.sugScriptId;
    sugdiv.src = url;
    document.body.appendChild(sugdiv);
  }

  function paintResult(W) {
    const sugdata = getElementId('sug_wraper');
    if (!W) {
      sugStatus.currentSugKw = '';
      sugdata.innerHTML = '';
      return;
    }

    if (Object.prototype.toString.call(W) !== '[object Array]') {
      return;
    }

    if (W[1].length === 0) {
      sugStatus.currentSugKw = '';
      displaynone();
      return;
    }

    if (sugStatus.currentSugKw === W[1]) {
      display();
      return;
    }
    sugdata.innerHTML = '';
    const tmp = [];
    tmp.push('<ul class="suggest_list">');

    for (let T = 0; T < W[1].length && T < info.sugNum; T += 1) {
      const Q = W[1][T];
      const U = new RegExp(`${W[0]}(.*)`);
      const S = U.exec(Q);
      let V = '';
      if (S) {
        V = `${W[0]}<strong>${S[1]}</strong>`;
      } else {
        V = `<strong>${Q}</strong>`;
      }
      tmp.push(`<li onclick="window.sug.select('${encodeURIComponent(escapeForSpecialChars(Q))}');">${V}</li>`);
    }

    tmp.push(suggTail);
    tmp.push('</ul>');
    sugdata.innerHTML = tmp.join('');
    [, sugStatus.currentSugKw] = W;
    display();
  }

  const focusHandle = function () {
    sugStatus.focus = true;
    setTimeout(L, 10);
  };

  const blurHandle = function () {
    sugStatus.focus = false;
  };

  function addListener() {
    getElementId(info.inputId).setAttribute('autocomplete', 'off');
    getElementId(info.inputId).addEventListener('focus', focusHandle, false);
    getElementId(info.inputId).addEventListener('blur', blurHandle, false);
  }

  function displaynone() {
    getElementId('sug_wraper').style.display = 'none';
  }

  function display() {
    getElementId('sug_wraper').style.display = 'block';
  }

  function L() {
    // if(sugStatus.isClose==1){return }
    if (sugStatus.focus) {
      let Q = getElementId(info.inputId).value;
      Q = Q.toLowerCase();
      Q = strip(Q);

      if (Q === '') {
        displaynone();
      } else {
        const R = sugStatus.cache[Q];
        if (R) {
          paintResult(R);
        } else {
          if (!sugStatus.isRequesting) {
            sugStatus.isRequesting = true;
            ajaj(encodeURIComponent(Q));
          }
        }
      }

      setTimeout(L, info.checkInterval);
    }
  }

  function sugCache(R) {
    Object.keys(sugStatus.cache).forEach((Q) => {
      if (R.indexOf(Q) >= 0 && sugStatus.cache[Q][1].length === 0) {
        return { q: R, s: [] };
      }
    });
    return null;
  }

  function search(R) {
    const form = document.forms[0];
    sugStatus.focus = false;
    form.keyword.value = decodeURIComponent(unescapeForSpecialChars(R));
    displaynone();
    // form.submit();
    setTimeout(() => {
      form.submit();
    }, 500);
  }

  createWrapper();
  sug.close = function () {
    displaynone();
    // sugStatus.isClose=1;
  };
  sug.select = search;
}

export default {
  sogouSugg,
};
